export const ITEM_UPLOAD_URL = '/items/new'
export const CATALOG_URL = '/catalog'
export const ACCESSIBILITY_URL = '/accessibility'
